import React from 'react'

import { Link } from '../../index'

export default function SubCategorySidebar({ categoryData }) {
  const { category_title: title, subcategories_data: subCategories } =
    categoryData

  return (
    <div className="shadow-sm mb-4">
      <strong className="d-flex align-center p-3 border-bottom-1 font-size-m">
        {title}
      </strong>
      <ul className="p-3">
        {subCategories
          .filter(({ include_in_sidebar }) => include_in_sidebar)
          .map(({ url, name }, index) => (
            <li key={index} className="mb-2">
              <Link href={url}>{name}</Link>
            </li>
          ))}
      </ul>
    </div>
  )
}
